

import { AlertController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { HttpClient } from '@angular/common/http';

interface AudioTextHistory {
  Text: string;
  Username: string;
  Gender: string;
  Age: string;
  Accent: string;
  Language: string;
  Type: string;
  AudioPath: string;
}

@Component({
  selector: 'app-text-record-history',
  templateUrl: './text-record-history.component.html',
  styleUrls: ['./text-record-history.component.scss'],
})

export class TextRecordHistoryComponent implements OnInit {
  @Input() initiator:string = "";
  @Input() currentTextIdForHistory:string = "";
  @Input() showDataOf:string = "";
  historyData: any[] = [];

  numberOfOwnDataDelete:number = 0;
  numberOfAllsDataDelete:number = 0;
  
  constructor(private modalCtrl: ModalController,private apiService:ApiService,private router:Router,private globalService:GlobalService,private http: HttpClient,private alertController: AlertController) {
   

  }
  ngOnInit(){
    console.log("this.currentTextIdForHistory is:",this.currentTextIdForHistory);
    console.log("this.showData of:",this.showDataOf);

    this.fetchAudioHistory(this.currentTextIdForHistory,this.showDataOf);
  }


  fetchAudioHistory(currentTextIdForHistory: string,showDataOf:string) {
      console.log("fetch the history");
      this.globalService.logoutLoading();
      

      this.apiService.getAudioTextHistory(currentTextIdForHistory,showDataOf).subscribe(response => {
        console.log('All History for text:', response);
        

        if (!response) {
            console.error("No response from API");
            this.globalService.dismissLoading();
            return;
        }
        this.historyData = response;

        this.globalService.dismissLoading();
        
        
      }, error => {
        console.error('Model Inferenced error:', error);
        this.globalService.dismissLoading();
      });
   

  }


  // deleteText(item:any) {
  //   console.log("fetch the history");
  //   this.globalService.logoutLoading();
    

  //   this.apiService.deleteAudioFile(item.AudiopathId).subscribe(response => {
  //     console.log('Deleted Audio is:', response);
      

  //     if (!response) {
  //         console.error("No response from API");
  //         this.globalService.dismissLoading();
  //         return;
  //     }

  //     this.globalService.dismissLoading();
      
      
  //   }, error => {
  //     console.error('Error on delete audio file:', error);
  //     this.globalService.dismissLoading();
  //   });
 

  // }
  async deleteText(item: any) {
    const alert = await this.alertController.create({
      header: 'Confirm Delete',
      message: 'Are you sure you want to delete this audio file?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Delete canceled');
          }
        },
        {
          text: 'Delete',
          handler: () => {
            console.log("fetch the history");
            this.globalService.logoutLoading();
  
            this.apiService.deleteAudioFile(item.AudiopathId).subscribe(response => {
              if(item.Username === localStorage.getItem('userName')){
                this.numberOfOwnDataDelete++;
                this.numberOfAllsDataDelete++;
              }else{
                this.numberOfAllsDataDelete++;
              }
              console.log('Deleted Audio is:', response);
  
              if (!response) {
                console.error("No response from API");
                this.globalService.dismissLoading();
                return;
              }
  
              this.globalService.dismissLoading();
  
              // Optionally remove the deleted item from the list
              this.historyData = this.historyData.filter(x => x.AudiopathId !== item.AudiopathId);
  
            }, error => {
              console.error('Error on delete audio file:', error);
              this.globalService.dismissLoading();
            });
          }
        }
      ]
    });
  
    await alert.present();
  }

  onUsableChange(event: any, item: any) {
    const selectedValue = event.detail.checked; // true if toggle is on, false if off
    console.log('Selected value:', selectedValue);
    console.log('Item:', item);
    // You can now use `selectedValue` and `item` as needed

    this.putSavedDataFun(selectedValue,item);
  }

  onIsForInterpretationOnlyChange(event: any, item: any){
    console.log("Enter to onIsForInterpretationOnlyChange function only");
    console.log('Item:', item);
    const selectedValue = event.detail.checked;
    this.putSavedDataFunForInterpretation(selectedValue,item);

  }

  putSavedDataFun(selectedValue: boolean, item: any) {
    // const lang = localStorage.getItem('language');
    // const cate = localStorage.getItem('textCategory');
    
    const AudiopathId = item.AudiopathId;
    const ClientId = localStorage.getItem('userId');
    const Usable = selectedValue;
    this.apiService.updateUsableValue(AudiopathId,ClientId,Usable).subscribe(
     (response) => {
       console.log("response is:",response);
      //  this.data = response
     },
     (err) => {
       console.log(err);
     }
   );
  }

  putSavedDataFunForInterpretation(selectedValue: boolean, item: any) {
    const AudiopathId = item.AudiopathId;
    const ClientId = localStorage.getItem('userId');
    const intepretationOnly = selectedValue
    this.apiService.updateInterpretationValue(AudiopathId,ClientId,intepretationOnly).subscribe(
    (response) => {
      console.log("response is:",response);
      //  this.data = response
    },
    (err) => {
      console.log(err);
    }
  );
  }
  

  formatDate(dateString: string): string {
    const date = new Date(dateString);
  
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  goToMenu() {
    this.router.navigate(['/menu']);
  }

  // closeModal(target:string) {
  //   if(this.numberOfAllsDataDelete !== 0 || this.numberOfOwnDataDelete !== 0 ){
  //     const data = {
  //       numberOfAllsDataDelete: this.numberOfAllsDataDelete,
  //       numberOfOwnDataDelete: this.numberOfOwnDataDelete
  //     };
  //   }else{
  //     const data = {
  //       numberOfAllsDataDelete: 0,
  //       numberOfOwnDataDelete: 0
  //     };
  //     this.modalCtrl.dismiss(data);
  //   }
   
  // }
  closeModal(target: string) {
    const data = {
      numberOfAllsDataDelete: this.numberOfAllsDataDelete !== 0 ? this.numberOfAllsDataDelete : 0,
      numberOfOwnDataDelete: this.numberOfOwnDataDelete !== 0 ? this.numberOfOwnDataDelete : 0
    };
  
    this.modalCtrl.dismiss(data);
  }
  


}

